import { Box, Snackbar as Base } from "@mui/material";
import { useState } from "react";
import Fade from "@mui/material/Fade";

export function Snackbar({ children, message }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Box onClick={handleClick}>{children}</Box>
      <Base
        open={open}
        autoHideDuration={3000}
        slots={{ transition: Fade }}
        onClose={handleClose}
        message={message}
      />
    </>
  );
}
